import { hbs } from 'ember-cli-htmlbars';
export default hbs("<div class=\'grid-3-cols-with-border-item\' ...attributes>{{yield}}</div>")